import axiosInstance from "@/utils/AxiosInstance";

const BASE_API = '/clients/validation';

const getClientsForValidation = async (requestParams: URLSearchParams): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}`, { params: requestParams });
}

const validateClient = async (body: any): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}`, body);
}

export default {
    getClientsForValidation,
    validateClient
}